import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';

import Pagination from '../../components/Pagination';
import Button from '../Button';
import Checkbox from '../Checkbox';
import config from '../../lib/config';

interface IProps {
  selectGroupVisible: boolean;
  setSelectGroupVisible: Function;
  group: any;
  setGroup: Function;
  groupName: any;
  setGroupName: Function;
  onSearchGroup: () => void;
  groupData: any;
  groupPage: number;
  setGroupPage: (page: number) => void;
  selection: any;
  setSelection: (selection: any) => void;
  onSetSelection: Function;
}

const SelectGroupModal: FC<IProps> = ({
  selectGroupVisible,
  setSelectGroupVisible,
  group,
  setGroup,
  groupName,
  setGroupName,
  onSearchGroup,
  groupData,
  groupPage,
  setGroupPage,
  selection,
  setSelection,
  onSetSelection,
}) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (group && group.length) {
      setSelection(group.map((groupNo: string) => Number(groupNo)));
    } else {
      setSelection([]);
    }
  }, [group]);

  const onSetGroup = () => {
    setGroup(selection);
    setSelectGroupVisible(false);
  }

  const onRemoveGroup = () => {
    setGroup([]);
    setGroupName('');
    setSelectGroupVisible(false);
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('board.notice.column10'),
      dataIndex: 'korName',
      key: 'korName',
      render: (value, record) => i18n.language === 'ko' ? value : record.engName,
    },
    {
      title: t('board.notice.column11'),
      dataIndex: 'hqYn',
      key: 'hqYn',
    },
    {
      title: '',
      dataIndex: 'groupNo',
      key: 'groupNo',
      render: value => {
        let checked = false;
        if (selection?.includes(value)) checked = true;

        return (
          <div className="text-center">
            <Checkbox
              checked={checked}
              onChange={() => onSetSelection(value)}
              text=""
            />
          </div>
        )
      }
    }
  ];

  return (
    <Modal
      title={t('board.notice.title7')}
      visible={selectGroupVisible}
      onCancel={onSetGroup}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSetGroup}
          >
            {t('board.notice.button1')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={onRemoveGroup}
          >
            {t('board.notice.button2')}
          </AntButton>
        </div>
      ]}
    >
      <div>
        <div className="form-group row">
          <div className="col-9">
            <input
              type="text"
              className="form-control"
              placeholder={t('board.notice.column10')}
              value={groupName}
              onChange={(e => setGroupName(e.target.value))}
              onKeyPress={e => { if (e.key === 'Enter') onSearchGroup() }}
            />
          </div>
          <div className="col-3">
            <Button
              className="btn btn-secondary w-100"
              onClick={onSearchGroup}
              text={t('common.button.search')}
            />
          </div>
        </div>
        <div className='comm-table__area'>
          <Table
            columns={columns}
            dataSource={groupData}
            pagination={{
              current: groupPage,
              pageSize: config.miniPageSize
            }}
          />
        </div>
        <div className="common-paging center">
          <Pagination
            count={groupData.length}
            page={groupPage}
            setPage={setGroupPage}
            mini
          />
        </div>
      </div>
    </Modal>
  );
}

export default SelectGroupModal;
